// extracted by mini-css-extract-plugin
export default {"button":"btn-icon-text_button__3-BaL"};